/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Weak_Lucky_Gadfly_FileInputs */

const fr_weak_lucky_gadfly_file = /** @type {(inputs: Weak_Lucky_Gadfly_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Êtes-vous sur de vouloir supprimer cette photo de profil ?`)
};

/**

* @param {Weak_Lucky_Gadfly_FileInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const weak_lucky_gadfly_file = /** @type {((inputs?: Weak_Lucky_Gadfly_FileInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Weak_Lucky_Gadfly_FileInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_weak_lucky_gadfly_file(inputs)
});